export const LEFT_TABS = ['Overview', 'Performance']

export const CHART_TABS = [
  'Total Equity',
  'Cumulative PnL',
  'PnL',
  'Return Percentage',
  'Equity Breakdown',
]

export const POSITIONS_TABS = [
  'Positions',
  'Assets',
  'Open Orders',
  'TWAP',
  'Strategies',
  'Order History',
  'Trade History',
  'Funding History',
  'Liquidations',
  'Public Pools',
  'Deposits',
  'Withdrawals',
  'Transfers',
]

export const FILTER_TYPES = [
  'Total Equity',
  'Spot Equity',
  'Perpetuals Equity',
  'Public Pools Equity',
  'Staking Equity',
]

export const FILTER_PERIODS = ['24H', '1W', '1M', '3M', '6M', 'All-time']

export const BALANCE_ROWS = [
  {
    testId: 'account-overview-total-account-value',
    label: 'Total Equity',
    help: true,
  },
  {
    testId: 'account-overview-perps-equity',
    label: 'Perpetuals Equity',
    help: true,
  },
  {
    testId: 'account-overview-spot-equity',
    label: 'Spot Equity',
    help: true,
  },
  {
    testId: 'account-overview-public-pool-equity',
    label: 'Public Pools Equity',
    help: true,
  },
  {
    testId: 'account-overview-staking-equity',
    label: 'Staking Equity',
    help: true,
  },
  {
    testId: 'account-overview-leased-lit',
    label: 'Credited in LIT',
    help: true,
  },
]

export const PERPS_ROWS = [
  {
    testId: 'perps-overview-unrealized-pnl',
    label: 'Unrealized PnL',
    help: true,
  },
  {
    testId: 'perps-overview-cross-leverage',
    label: 'Cross Leverage',
    help: true,
  },
  {
    testId: 'perps-overview-maintenance-margin-requirement',
    label: 'Maintenance Margin',
    help: true,
  },
  {
    testId: 'perps-overview-cross-margin-usage',
    label: 'Cross Margin Usage',
    help: true,
  },
  {
    testId: 'perps-overview-cross-margin-ratio',
    label: 'Cross Margin Ratio',
    help: true,
  },
]

export const PERFORMANCE_ROWS = [
  { testId: 'account-stat-pnl', label: 'PnL', share: true },
  {
    testId: 'account-stat-return_percentage',
    label: 'Return Percentage',
    share: true,
  },
  {
    testId: 'account-stat-average_returns',
    label: 'Average Daily PnL',
    share: true,
  },
  {
    testId: 'account-stat-volatility',
    label: 'PnL Volatility',
    help: true,
    share: true,
  },
  {
    testId: 'account-stat-sharpe_ratio',
    label: 'Sharpe Ratio',
    help: true,
    share: true,
  },
  {
    testId: 'account-stat-max_drawdown',
    label: 'Maximum Drawdown',
    help: true,
    share: true,
  },
]

export const ACTIVITY_ROWS = [
  { testId: 'account-stat-volume', label: 'Volume', share: true },
  {
    testId: 'account-stat-estimated_fees',
    label: 'Estimated Fees Saved',
    help: true,
    share: true,
    valueClass: 'text-link',
  },
]
